import { Checkbox } from "@/components/ui/checkbox";
import { Label } from "@/components/ui/label";
import { FEATURES } from "@/types/features";

interface FeatureListProps {
  selectedFeatures: string[];
  onFeatureChange: (features: string[]) => void;
}

export const FeatureList = ({ selectedFeatures, onFeatureChange }: FeatureListProps) => {
  return (
    <div className="space-y-4">
      {FEATURES.map((feature) => (
        <div key={feature.id} className="flex items-center space-x-2">
          <Checkbox
            id={feature.id}
            checked={selectedFeatures.includes(feature.id)}
            onCheckedChange={(checked) => {
              onFeatureChange(
                checked
                  ? [...selectedFeatures, feature.id]
                  : selectedFeatures.filter(f => f !== feature.id)
              );
            }}
          />
          <Label htmlFor={feature.id}>{feature.label}</Label>
        </div>
      ))}
    </div>
  );
};